
angular.module('MW.Configuration.FeatureToggles', []);
angular.module('MW.Configuration.Elevio', []);
angular.module('MW.DashboardLegacy.Constants', []).constant('DASHBOARD_LEGACY_TRANSLATIONS', '');
angular.module('EnvironmentConfiguration', []);
angular.module('ladda', []);
angular.module('angulartics.segment.io', []);